import {Component, OnInit} from '@angular/core';
import {ManageTaBaseComponent} from '../manage-ta-base-component.directive';
import {ManageTaDayTripPaymentTable} from '../manage-ta-day-trip-payment-table/manage-ta-day-trip-payment-table';

/** Day trip payment split for statuses past finalisation, which have no page of their own. */
@Component({
  selector: 'manage-ta-day-trip-breakdown',
  imports: [
    ManageTaDayTripPaymentTable,
  ],
  templateUrl: './manage-ta-day-trip-breakdown.component.html',
})
export class ManageTaDayTripBreakdownComponent extends ManageTaBaseComponent implements OnInit {
  // The rows read every itinerary version, which nothing else on these pages loads.
  override ngOnInit() {
    super.ngOnInit();
    this.taSubmissionDatasource.getAllItineraries();
  }
}
